import classnames from 'classnames'
import React from 'react'
import { HashLink } from 'react-router-hash-link'

import styles from './index.module.css'

class Checkbox extends React.Component {
  render() {
    const { value, count, onSelectionChange, checked, link } = this.props
    const checkboxStyles = classnames(styles.checkbox, {
      [styles.checked]: checked
    })

    return (
      <div className={styles.optionWrapper}>
        <HashLink
          onClick={onSelectionChange.bind(null, value)}
          to={link}
          className={styles.link}
        >
          <span className={checkboxStyles} />
          {this.props.children}
        </HashLink>
        <span className={styles.count}>{count}</span>
      </div>
    )
  }
}

export default Checkbox
